<template>
  <b-toast id="kobe-toast" :variant="toastVariant" solid>
    <template v-slot:toast-title>
      <div class="d-flex flex-grow-1 align-items-baseline">
        <strong class="mr-auto">{{toastHeader}}</strong>
      </div>
    </template>
    {{toastContent}}
  </b-toast>
</template>

<script>
export default {
  name: 'KToast',
  props: {
    variant: String,
    header: String,
    content: String
  },
  data() {
    return {
      toastVariant: '',
      toastHeader: '',
      toastContent: ''
    };
  },
  watch: {
    variant(value) {
      this.toastVariant = value;
    },
    header(value) {
      this.toastHeader = value;
    },
    content(value) {
      this.toastContent = value;
    }
  }
};
</script>
<style>
#kobe-toast > .toast-header {
  padding: 4px 12px;
}
#kobe-toast > .toast-body {
  padding: 12px;
}
</style>



// WEBPACK FOOTER //
// KToast.vue?050c2e99